import styles from "./Transaction.module.css";

const TransactionError = () => {
  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        <p className={styles.heading}>Transaction under review</p>
      </div>

      <div className={styles.transactionMessage}>
        <img src="/assets/TransactionMessage.svg" />
      </div>
    </div>
  );
};

export default TransactionError;
